import { useState } from "react";
import { E, useEditableContent } from "@/components/EditableText";
import { SUN_DEEP } from "@/components/guardian/pricing/config";

/* TeamBio — clamped read-more block. In edit mode the full text is shown so
 * the inline editor (<E>) can be used freely. */
export function TeamBio({ i, text }) {
  const { editMode } = useEditableContent();
  const [expanded, setExpanded] = useState(false);
  const clamp = !editMode && !expanded;
  return (
    <div className="text-sm opacity-80 leading-relaxed">
      <p
        style={
          clamp
            ? { display: "-webkit-box", WebkitLineClamp: 5, WebkitBoxOrient: "vertical", overflow: "hidden" }
            : undefined
        }
      >
        <E k={`team.m${i + 1}.bio`} defaultText={text} as="span" multiline />
      </p>
      {!editMode && (
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          className="pcp-mono text-[10px] mt-2 inline-flex items-center gap-1 hover:opacity-100 opacity-65 transition"
          style={{ color: SUN_DEEP, letterSpacing: "0.18em" }}
          data-testid={`team-bio-toggle-${i}`}
        >
          {expanded ? "Read less ↑" : "Read more ↓"}
        </button>
      )}
    </div>
  );
}
